import referalService, {
  IReferralActionData,
} from '../_service/referal.service'
import { getSession, getUser, getUTM } from './get.store'

export const track = async ({
  action_type,
  order_id,
  customer_id,
  tg_chat_id,
  platform_id,
  device_id,
  fcm_token,
  referal_url_id,
}: Partial<IReferralActionData>) => {
  try {
    const session = getSession()
    const utm = getUTM()
    const user = getUser()

    await referalService.action({
      referal_url_id: referal_url_id || utm.referal_url_id || null,
      platform_id: platform_id || session.platform_id,
      source_id: platform_id || session.platform_id,
      customer_id: customer_id || user?.id || '',
      device_id: device_id || session.device_id,
      fcm_token: fcm_token || session.fcm_token,
      action_type: action_type || 'enter',
      order_id: order_id || '',
      tg_chat_id,
    })

    return true
  } catch (error) {
    console.log(error)
    return false
  }
}
